import useQRCode from "@hooks/useQRCode";
import useResizeObserver from "@hooks/useResizeObserver";
import { cx } from "class-variance-authority";
import { HTMLAttributes, Ref } from "react";

interface Props extends HTMLAttributes<HTMLCanvasElement> {
    value: string;
    containerClassName?: string;
}

const QRCode = ({ value, containerClassName, ...props }: Props) => {
    const [containerRef, { width, height }] = useResizeObserver();

    useQRCode(value, containerRef, { width, height });

    return <div ref={containerRef as Ref<HTMLDivElement>} className={cx(containerClassName)}></div>;
};

export default QRCode;
